import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import FactoryRushCapacityProductGroup from "./factory-rush-capacity-product-group.model";

export default class FactoryRushCapacityProductGroupFactory
  implements ObjectBuilderInterface<FactoryRushCapacityProductGroup> {
  public buildFromJSON(data: {
    [key: string]: any;
  }): FactoryRushCapacityProductGroup {
    const value = new FactoryRushCapacityProductGroup(data.id, data.name);

    (value as any).fCreatedAt = new Date(data.createdAt);
    (value as any).fUpdatedAt = new Date(data.updatedAt);

    value.isNew = false;

    return value;
  }
}
